import { FulfillmentTypeListResponseType } from "@sellar-io/api-v2/types";
import {
  formatCurrency,
  generateFulfillmentTypeContainerDeliveryChargeName,
} from "@sellar-io/common";
import { useState } from "react";
import { Icon } from "../../../components";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../../components/table/TableLegacy";
import { FulfillmentTypeContainerDeliveryChargeUpdateDialog } from "./dialogs/FulfillmentTypeContainerDeliveryChargeUpdateDialog";

export function FulfillmentTypeContainerDeliveryChargeTableRow({
  fulfillmentTypeContainerDeliveryCharge,
}: {
  fulfillmentTypeContainerDeliveryCharge: FulfillmentTypeListResponseType[number]["FulfillmentTypeContainerDeliveryCharges"][number];
}) {
  const [active, setActive] = useState<boolean>(false);
  return (
    <>
      <TableLegacyTR>
        <TableLegacyTD className={"w-8/12"}>
          {generateFulfillmentTypeContainerDeliveryChargeName({
            volume: fulfillmentTypeContainerDeliveryCharge.volume,
            packQuantity: fulfillmentTypeContainerDeliveryCharge.packQuantity,
            displayUnit: fulfillmentTypeContainerDeliveryCharge.displayUnit,
            containerType: fulfillmentTypeContainerDeliveryCharge.containerType,
          })}
        </TableLegacyTD>
        <TableLegacyTD>
          {formatCurrency(fulfillmentTypeContainerDeliveryCharge.charge)}
        </TableLegacyTD>
        <TableLegacyTD
          className={"cursor-pointer"}
          onClick={() => setActive(true)}
        >
          <Icon icon={"PENCIL"} />
        </TableLegacyTD>
      </TableLegacyTR>
      <FulfillmentTypeContainerDeliveryChargeUpdateDialog
        active={active}
        onDismiss={() => setActive(false)}
        fulfillmentTypeContainerDeliveryCharge={
          fulfillmentTypeContainerDeliveryCharge
        }
      />
    </>
  );
}
